<ng-container [formGroup]="formGroup" >

  <mat-card>
    <hr>
      <mat-checkbox (change)="toggleSelectAll($event)"
        [checked]="areAllSelected">
        {{'Select all' | translate}}
      </mat-checkbox>
      <hr>
        <mat-selection-list #photoCategorySelection>
          @for (assignedPhotoCategory of assignedPhotoCategories; track assignedPhotoCategory) {
            <mat-list-option
              [selected]="assignedPhotoCategory.assigned"
              (click)="togglePhotoCategory(assignedPhotoCategory)"
              >
              <div mat-line>{{assignedPhotoCategory?.photoCategory.name}}</div>
            </mat-list-option>
          }
        </mat-selection-list>
        <hr>
          <p>
            {{'Photo Categories selected' | translate}}: {{photoCategorySelection.selectedOptions.selected.length}}
          </p>

        </mat-card>

      </ng-container>
